import React, { useState } from "react";
import NewInvoiceGreen from "./NewInvoiceGreen";
import DueInvoiceGreenAll from "./DueInvoiceGreenAll";
import OverDueInvoiceGreenAll from "./OverDueInvoiceGreenAll";
import PaidInvoiceGreenAll from "./PaidInvoiceGreenAll";


const MainInvoicePage = () => {
  const [activeTab, setActiveTab] = useState(0); // 0 is the index for the first tab

  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return <NewInvoiceGreen></NewInvoiceGreen>;
      case 1:
        return <DueInvoiceGreenAll></DueInvoiceGreenAll>;
      case 2:
        return <OverDueInvoiceGreenAll></OverDueInvoiceGreenAll>;
      case 3:
        return <PaidInvoiceGreenAll></PaidInvoiceGreenAll>;
      default:
        return null;
    }
  };

  return (
    <div className="bg-green-100 h-screen">
      <div className="w-full h-20 flex justify-start pl-5 items-center bg-gree-100 shadow-md">
        <h2 className="text-xl text600 text-start text-green-900 font-montserrat">
          All Invoice
        </h2>
      </div>
      <div className="m-5 flex flex-row gap-5">
        <button
          onClick={() => setActiveTab(0)}
          className={activeTab === 0 ? "bg-green-900 shadow-xl rounded font-montserrat text-lg px-6 text-white py-2" : "bg-green-600 text-white rounded font-montserrat text-lg px-6 py-2"}
        >
          New Invoice
        </button>
        <button
          onClick={() => setActiveTab(1)}
          className={activeTab === 1 ? "bg-green-900 shadow-xl rounded font-montserrat text-lg px-6 text-white py-2" : "bg-green-600 text-white rounded font-montserrat text-lg px-6 py-2"}
        >
          Due Invoice
        </button>
        <button
          onClick={() => setActiveTab(2)}
          className={activeTab === 2 ? "bg-green-900 shadow-xl rounded font-montserrat text-lg px-6 text-white py-2" : "bg-green-600 text-white rounded font-montserrat text-lg px-6 py-2"}
        >
          Over Due Invoice
        </button>
        <button
          onClick={() => setActiveTab(3)}
          className={activeTab === 3 ? "bg-green-900 shadow-xl rounded font-montserrat text-lg px-6 text-white py-2" : "bg-green-600 text-white rounded font-montserrat text-lg px-6 py-2"}
        >
          Paid Invoice
        </button>
      </div>
      <div>{renderTabContent()}</div>
    </div>
  );
};

export default MainInvoicePage;
